import { marked } from "marked";
import { lenientEmphasis } from "@utils/markedExtensions";
import sanitizeHtml from "sanitize-html";

marked.setOptions({ breaks: true, gfm: true });
marked.use(lenientEmphasis());

const SANITIZE_OPTIONS = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    "*": ["class"],
  },
};

export function renderMarkdown(text) {
  if (!text) return "";
  return sanitizeHtml(marked(text), SANITIZE_OPTIONS);
}

// Renders inline-only markdown (bold, italic, links, code) without wrapping
// the result in a <p>. Use this for titles, labels, or any content that lives
// inside an existing inline/heading container.
export function renderMarkdownInline(text) {
  if (!text) return "";
  return sanitizeHtml(marked.parseInline(text), SANITIZE_OPTIONS);
}
